import { Pipe, PipeTransform } from '@angular/core';
import { SignHelper } from 'src/app/helpers/sign-helper';
import { StringHelper } from 'src/app/helpers/string-helper';

@Pipe({
  name: 'formatIPBoardDimensions'
})
export class FormatIPBoardDimensionsPipe implements PipeTransform {
  transform(
    isAdhesiveBoard: boolean,
    signHeight: number,
    signWidth: number,
    signShapeIsUpright: boolean,
    otherSignHeight: number,
    otherSignWidth: number,
    withUnits = true
  ): string {
    if (signHeight != null || signWidth != null) {
      const left = signShapeIsUpright ? signHeight : signWidth;
      const right = signShapeIsUpright ? signWidth : signHeight;
      return StringHelper.join(
        [
          left == null ? null : `${left}${withUnits ? ' H' : ''}`,
          right == null ? null : `${right}${withUnits ? ' B' : ''}`
        ],
        ' x '
      );
    } else if (otherSignHeight != null || otherSignWidth != null) {
      if (isAdhesiveBoard) {
        [
          otherSignWidth,
          otherSignHeight
        ] = SignHelper.getActualAdhesiveBoardDimensions(
          otherSignWidth,
          otherSignHeight
        );
      }
      return StringHelper.join(
        [
          otherSignHeight == null
            ? null
            : `${otherSignHeight}${withUnits ? ' H' : ''}`,
          otherSignWidth == null
            ? null
            : `${otherSignWidth}${withUnits ? ' B' : ''}`
        ],
        ' x '
      );
    } else {
      return '';
    }
  }
}
